import React, { Component } from "react";
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome'
import { Button, Modal }    from "react-bootstrap";
import LoaderButton         from "../../components/LoaderButton";
import { WhiteLabel }       from "../../utils/WhiteLabelProps";
import "../../css/modal/ModalProgramSummary.css";

var white_label = WhiteLabel();
const MainColor = white_label.company_primary_btn_color;

export default class ModalLoadingInfo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModalLoadingInfo: false
        };
    }

    createMarkup(text) { return {__html: text}; };

    render() {
        var width       = this.props.modalWidth;
        var height      = this.props.modalHeight;
        var margin_left = width/2;

        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                dialogClassName = "modal-90w"
                style={{position:"absolute", top:120, left: "50%", width: width, marginLeft: -margin_left}}
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="marketplaceModalTitle">
                            Message
                            { /*}<FontAwesomeIcon icon="sticky-note" />*/ }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{height: height}}>
                      <div className="marketplaceModalProgramSummary">
                          <b></b>
                        <div dangerouslySetInnerHTML={this.createMarkup(this.props.message)} />
                      </div>
                </Modal.Body>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalLoadingInfo.js